<template>
    <div class="zap-routine">
        <div class="zap-toolbar">
            <div class="athlete-nav" v-if="needsNav">
                <button class="athlete-nav-btn" :disabled="startIdx === 0" @click="prev">
                    <v-icon size="16">mdi-chevron-left</v-icon>
                </button>
                <div class="athlete-dots">
                    <div v-for="(routine, i) in routines" :key="routine.id" class="athlete-dot"
                        :class="{ active: isDotActive(i) }" @click="goTo(i)"></div>
                </div>
                <button class="athlete-nav-btn" :disabled="startIdx + windowSize >= routines.length" @click="next">
                    <v-icon size="16">mdi-chevron-right</v-icon>
                </button>
            </div>
            <div v-else class="athlete-nav"></div>
            <button class="btn-zap-reset" @click="$emit('reset')">{{ $t('common.reset') }}</button>
        </div>

        <div class="zap-multi-view">
            <zapping-routine-detail v-for="routine in visibleRoutines" :key="routine.id" :routine="routine" />
        </div>
    </div>
</template>

<script>
import ZappingRoutineDetail from './ZappingRoutineDetail.vue'

export default {
    name: 'ZappingColumns',
    components: { ZappingRoutineDetail },
    props: {
        routines: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            startIdx: 0,
        }
    },
    computed: {
        windowSize(vm = this) {
            return vm.isMobile ? 1 : 3
        },
        needsNav(vm = this) {
            return vm.routines.length > vm.windowSize
        },
        visibleRoutines(vm = this) {
            return vm.routines.slice(vm.startIdx, vm.startIdx + vm.windowSize)
        },
    },
    methods: {
        isDotActive(i) {
            return i >= this.startIdx && i < this.startIdx + this.windowSize
        },
        prev() {
            if (this.startIdx > 0) this.startIdx--
        },
        next() {
            if (this.startIdx + this.windowSize < this.routines.length) this.startIdx++
        },
        goTo(i) {
            const vm = this
            const max = Math.max(0, vm.routines.length - vm.windowSize)
            vm.startIdx = Math.min(i, max)
        },
        clamp() {
            const vm = this
            const max = Math.max(0, vm.routines.length - vm.windowSize)
            if (vm.startIdx > max) vm.startIdx = max
        },
    },
    watch: {
        routines() {
            this.startIdx = 0
        },
        windowSize() {
            this.clamp()
        },
    },
}
</script>

<style scoped>
.zap-routine {
    display: flex;
    flex-direction: column;
    --zap-head-top: 52px;
}

.zap-toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 4px 12px;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 5;
    background: var(--v-bg-base);
}

.athlete-nav {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.athlete-nav-btn {
    width: 30px;
    height: 30px;
    border-radius: 7px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--v-txtSecondary-base);
    transition: all 0.15s;
    flex-shrink: 0;
}

.athlete-nav-btn .v-icon {
    color: var(--v-txtSecondary-base);
}

.athlete-nav-btn:hover {
    background: var(--v-surface2-base);
}

.athlete-nav-btn:disabled {
    opacity: 0.3;
    pointer-events: none;
}

.athlete-dots {
    display: flex;
    gap: 5px;
    align-items: center;
    flex-wrap: wrap;
}

.athlete-dot {
    height: 7px;
    width: 7px;
    border-radius: 4px;
    background: var(--v-outline2-base);
    transition: all 0.25s cubic-bezier(0.34, 1.4, 0.64, 1);
    cursor: pointer;
}

.athlete-dot.active {
    width: 22px;
    background: var(--brand-gradient);
}

.athlete-dot:hover:not(.active) {
    background: var(--v-txtMuted-base);
}

.btn-zap-reset {
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline2-base);
    border-radius: 7px;
    padding: 7px 14px;
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
    flex-shrink: 0;
}

.btn-zap-reset:hover {
    border-color: var(--v-error-base);
    color: var(--v-error-base);
}

.zap-multi-view {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

@media (max-width: 959px) {
    .zap-routine {
        --zap-head-top: calc(116px + var(--safe-area-inset-top, 0px));
    }

    .zap-toolbar {
        top: calc(64px + var(--safe-area-inset-top, 0px));
    }

    .zap-multi-view {
        display: block;
    }
}
</style>
